import NavBar from "../Componentes/NavBar"
import AdmissaoBody from "../Componentes/AdmissaoBody"
import 'react-toastify/dist/ReactToastify.css';

import Overlay from "../Componentes/Overlay"
import SideMenu from "../Componentes/SideMenu"
import SideMenuBtn from "../Componentes/SideMenuBtn"

import { useState, useEffect, useCallback, useContext } from "react"
import { ToastContainer } from 'react-toastify';
import SquareTransfer from "../Componentes/SquareTransfer"
import SquareNewTransfer from "../Componentes/SquareNewTransfer"
import SquareAdmis from "../Componentes/SquareAdmis"
import ModalEmailsTransferencia from "../Componentes/EmailsTransferencia/ModalEmailsTransferencia"
import { AuthContext } from "../Auth/AuthProvider"
import { VerifyPermission } from "../Funcoes/VerifyPermission"
import useApi from "../hooks/useApi"
import { useModal } from "../contexts/ModalContext"

const MODAL_TRANSFER = 'squareTransfer';
const MODAL_NEW_TRANSFER = 'squareNewTransfer';
const MODAL_ADMIS = 'squareAdmis';
const MODAL_EMAILS = 'emailsTransferencia';

const Admissao = () => {

    const { user } = useContext(AuthContext);
    const api = useApi();
    const { isModalOpen, openModal, closeModal } = useModal();
    const podeGerenciarEmails = VerifyPermission(user, {
        modulo: "rh",
        submodulo: "processo-adm",
        funcao: "gerenciar-emails",
    });

    const [overlaySidebar, setOverlaySidebar] = useState(false);

    const openSidebar = () => setOverlaySidebar(true);
    const closeSidebar = () => setOverlaySidebar(false);

    /* Quando o usuário clica numa linha existente, gravamos só o id e o
       modal correspondente (admissão = editável, transferência = leitura)
       faz a busca completa no banco via GetProcessoInfo. */
    const [editingId, setEditingId] = useState(null);

    const openAdmis = () => {

        setOverlaySidebar(false);
        setEditingId(null);
        openModal(MODAL_ADMIS);

    }

    const openTransfer = () => {

        setOverlaySidebar(false);
        setEditingId(null);
        openModal(MODAL_NEW_TRANSFER);

    }

    const openEmailsTransferencia = () => {

        if (!podeGerenciarEmails) return;
        setOverlaySidebar(false);
        openModal(MODAL_EMAILS);

    }

    const closeAdmisModal = () => {

        setEditingId(null);
        closeModal();

    }

    const closeTransferModal = () => {

        setEditingId(null);
        closeModal();

    }

    const openToEdit = (obj) => {

        if (!obj?.id || !obj?.motivo) return;

        setEditingId(obj.id);

        if (obj.motivo === 'ADMISSAO') {
            openModal(MODAL_ADMIS);
        } else {
            openModal(MODAL_TRANSFER);
        }

    }

    const [admissions, setAdimissions] = useState([]);
    const [admissionsFilter, setAdimissionsFilter] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetch_admissions = async () => {

        setLoading(true);
        try {

            const { data } = await api.get('/Painel/API/GetAdmissions/');

            const list = Array.isArray(data) ? data : [];
            if (!Array.isArray(data)) {
                console.warn('GetAdmissions retornou um payload não-array:', data);
            }

            setAdimissions(list);
            setAdimissionsFilter(list);

        } catch (error) {

            console.log(error);
            setAdimissions([]);
            setAdimissionsFilter([]);

        } finally {

            setLoading(false);

        }

    }

    const [obrasAtivas, setObrasAtivas] = useState([]);
    const [functions, setFunctions] = useState([]);
    const [lideres, setLideres] = useState([]);

    const getObrasAtivas = async () => {

        try {

            const { data } = await api.get('/Painel/API/GetObrasAtivas/')

            const obrasValues = data.map((obj) => (
                obj.OBRA
            ))

            setObrasAtivas(obrasValues)

        } catch (error) {

            console.log(error)

        }

    }

    const getFunctions = async () => {

        try {

            const { data } = await api.get('/Painel/API/GetFunctions/')
            setFunctions(data)

        } catch (error) {

            console.log(error)

        }

    }

    const getLideres = async () => {

        try {

            const { data } = await api.get('/Painel/assets/php/getLideres.php')

            const lideresOpts = (Array.isArray(data) ? data : []).map((lider) => ({
                value: lider.MATRICULA,
                label: lider.RA_NOMECMP
            }))

            setLideres(lideresOpts)

        } catch (error) {

            console.log(error)

        }

    }

    useEffect(() => {

        fetch_admissions();
        getObrasAtivas();
        getFunctions();
        getLideres();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleFilter = useCallback((nameFilter, cpfFilter, funcaoFilter, origemFilter, destinoFilter, motivoFilter, desistFilter, statusFilter, startDateFilter, endDateFilter) => {

        const cpfFormated = cpfFilter.replace(/\D/g, '');
        const statusValue = statusFilter && typeof statusFilter === 'object' ? statusFilter.value : undefined;
        const desistValue = desistFilter && typeof desistFilter === 'object' ? desistFilter.value : undefined;
        const motivoValue = motivoFilter && typeof motivoFilter === 'object' ? motivoFilter.value : undefined;

        const filtered = admissions.filter(item => {

            const name = !nameFilter || item.nome?.includes(nameFilter);
            const cpf = !cpfFilter || item.cpf?.includes(cpfFormated);
            const funcao = funcaoFilter.length === 0 || funcaoFilter.some(func => item.funcao?.includes(func.value));
            const origem = origemFilter.length === 0 || origemFilter.some(obra => (item.cc_origem || '').includes(obra.value));
            const destino = destinoFilter.length === 0 || destinoFilter.some(obra => item.cc_destino?.includes(obra.value));
            const motivo = motivoValue === undefined || item.motivo === motivoValue;
            const desist = desistValue === undefined || (desistValue === 'SIM'
                ? (item.desistente === '*')
                : (item.desistente === null)
            );
            const status = statusValue === undefined || (statusValue === 'EM ANDAMENTO'
                ? (item.status !== 'ENTROU NO SITE' && item.desistente === null)
                : (item.status === 'ENTROU NO SITE' || item.desistente !== null)
            );
            const start_date = !startDateFilter || item.data >= startDateFilter;
            const end_date = !endDateFilter || item.data <= endDateFilter;


            return name && cpf && funcao && origem && destino && motivo && desist && status && start_date && end_date;

        })

        setAdimissionsFilter(filtered);

    }, [admissions])

    return (

        <>

            <NavBar setSideBar={openSidebar} title="PROC. ADMISSIONAL / TRANFERÊNCIA" />

            <AdmissaoBody
                tabelaValues={admissionsFilter}
                tabelaForFilters={admissions}
                filterTable={handleFilter}
                openToEdit={openToEdit}
                isLoading={loading}
            />

            <Overlay
                state={overlaySidebar}
                changeContent={closeSidebar}
            >
                <SideMenu>
                    <SideMenuBtn
                        button="NOVO COLABORADOR"
                        clickFunc={openAdmis}
                    />
                    <SideMenuBtn
                        button="TRANSFERIR COLABORADOR"
                        clickFunc={openTransfer}
                    />
                    {podeGerenciarEmails && (
                        <SideMenuBtn
                            button="GERENCIAR E-MAILS"
                            clickFunc={openEmailsTransferencia}
                        />
                    )}
                </SideMenu>
            </Overlay>

            {isModalOpen(MODAL_TRANSFER) && (
                <SquareTransfer
                    onClose={closeTransferModal}
                    obras={obrasAtivas}
                    lideres={lideres}
                    editingId={editingId}
                />
            )}

            {isModalOpen(MODAL_NEW_TRANSFER) && (
                <SquareNewTransfer
                    onClose={closeTransferModal}
                    getNewValues={fetch_admissions}
                    obras={obrasAtivas}
                    lideres={lideres}
                />
            )}

            {isModalOpen(MODAL_ADMIS) && (
                <SquareAdmis
                    onClose={closeAdmisModal}
                    getNewValues={fetch_admissions}
                    obras={obrasAtivas}
                    functions={functions}
                    lideres={lideres}
                    editingId={editingId}
                />
            )}

            {podeGerenciarEmails && isModalOpen(MODAL_EMAILS) && (
                <ModalEmailsTransferencia obras={obrasAtivas} onClose={closeModal} />
            )}

            <ToastContainer
                style={{
                    zIndex: 99999
                }}
                autoClose={3000}
                position="top-center"
                theme="dark"
            />

        </>

    )

}

export default Admissao
